import React from "react";
import { styleBlock } from "../styleBlock";
const style = styleBlock("payment-method-list--item");
const PaymentMethodListItem = ({ className, selected, onChange, label, imgUrl, name, value, }) => (React.createElement("label", { className: style.mix(selected && "selected", className) },
    React.createElement("input", { type: "radio", name: name, value: value, checked: selected, onChange: onChange }),
    React.createElement("div", { className: "w-100 d-flex align-items-center" },
        React.createElement("div", { className: style("image") }, imgUrl && React.createElement("img", { className: style("icon"), src: imgUrl, alt: "" })),
        React.createElement("div", { className: style("inner") },
            React.createElement("div", { className: style("title") }, label)))));
export default PaymentMethodListItem;
//# sourceMappingURL=index.js.map